import { gql } from '@apollo/client';

// Import TimeRange enum values for the price history query
export const TimeRange = {
  ONE_DAY: 'ONE_DAY',
  ONE_WEEK: 'ONE_WEEK',
  ONE_MONTH: 'ONE_MONTH',
  THREE_MONTHS: 'THREE_MONTHS',
  ONE_YEAR: 'ONE_YEAR',
  ALL_TIME: 'ALL_TIME',
};

export const GET_POSITIONS = gql`
  query GetPositions($portfolioId: ID!) {
    positions(portfolioId: $portfolioId) {
      id
      token {
        id
        name
        ticker
        isDelisted
        coingeckoId
        coingeckoSlug
        chartSymbol
        group {
          id
          name
          description
        }
        location {
          id
          name
          description
        }
        marketData {
          id
          currentPrice
          priceChange1h
          priceChange24h
          priceChange7d
          priceChange30d
          priceChange1y
          volume24h
          marketCap
          fullyDilutedValuation
          marketCapFdvRatio
          marketCapCategory
          timestamp
        }
      }
      holdingsAmount
      holdingsValue
      locationBalances {
        locationId
        name
        quantity
      }
      averageNetCost
      averageBuyPrice
      investedCost
      current {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      unrealized {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      planned {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      plannedConservative {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      total {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      totalConservative {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      exitStrategy {
        levels {
          id
          amount
          price
          status
          warning
        }
        sellAmount
        proceeds
        cost
        templateId
        templateName
        isModified
        templateOutOfSync
        params {
          targetMultiple
          baseSource
          exitLevelsCount
          exitLevelsSpread
          takeInitialsEnabled
          takeInitialsMultiple
          hodlEnabled
          hodlPercentage
          advancedDistributionEnabled
          distributionCurve
          distributionFocus
          distributionIntensity
        }
      }
      strategyStatus {
        status
        tooltip
        exitStatus
        exitTooltip
        invalidationStatus
        invalidationTooltip
      }
      invalidationLevel {
        id
        templateId
        templateName
        isPriceTriggered
        isTimeTriggered
        priceDropPercentRemaining
      }
      tags {
        id
        name
        slug
        color
      }
    }
    tokenGroups(portfolioId: $portfolioId) {
      id
      name
      description
    }
  }
`;

export const GET_POSITION = gql`
  query GetPosition($id: ID!, $portfolioId: ID!) {
    position(id: $id, portfolioId: $portfolioId) {
      id
      token {
        id
        ticker
        name
        isDelisted
        description
        coingeckoId
        coingeckoApiId
        coingeckoSlug
        chartSymbol
        twitterUrl
        websiteUrls
        repositoryUrls
        marketData {
          id
          currentPrice
          priceChange1h
          priceChange24h
          priceChange7d
          priceChange30d
          priceChange1y
          volume24h
          marketCap
          fullyDilutedValuation
          marketCapFdvRatio
          marketCapCategory
          timestamp
        }
        sentimentHistory(limit: 10) {
          ticker
          description
          pros
          cons
          score
          timestamp
          sources {
            url
            title
          }
        }
        group {
          id
          name
          description
        }
        location {
          id
          name
          description
        }
      }
      holdingsAmount
      holdingsValue
      averageNetCost
      averageBuyPrice
      averageSellPrice
      investedCost
      current {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      unrealized {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      planned {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      plannedConservative {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      total {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      totalConservative {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      exitStrategy {
        levels {
          id
          amount
          price
          status
          warning
        }
        sellAmount
        proceeds
        cost
        templateId
        templateName
        isModified
        templateOutOfSync
        params {
          targetMultiple
          baseSource
          exitLevelsCount
          exitLevelsSpread
          takeInitialsEnabled
          takeInitialsMultiple
          hodlEnabled
          hodlPercentage
          advancedDistributionEnabled
          distributionCurve
          distributionFocus
          distributionIntensity
        }
      }
      tags {
        id
        name
        slug
        color
      }
      transactions {
        id
        transactionType
        price
        quantity
        timestamp
        fees
        feeQuantity
        cost
        proceeds
        notes
        createdAt
        updatedAt
        realizedPnl
        costBasis
        remainingQuantity
        remainingCostBasis
      }
    }
  }
`; 